<template id="entity-form">
  <v-form ref="entityForm">
    <v-row>
      <v-col class="col-6">
      <lb-string
        label="Name"
        v-model="modifydata['name']"
        :error="errors['name']"
        class="always-float-label"
      />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          label="Type"
          v-model="modifydata['type']"
          :error="errors['type']"
          :items="selectdata.type"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-string
          label="Contact Person"
          v-model="modifydata['contactperson']"
          :error="errors['contactperson']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-string
          label="Email"
          v-model="modifydata['contactemail']"
          :error="errors['contactemail']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-number
          label="Contact No."
          v-model="modifydata['contactno']"
          :error="errors['contactno']"
          type="tel"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          v-model="modifydata['industry']"
          :items="industries"
          label="Industry*"
          :error="errors['industry']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          v-model="modifydata['sector']"
          :items="sectors[modifydata['industry']]"
          label="Sector*"
          :error="errors['sector']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          v-model="modifydata['size']"
          :items="size"
          label="Size*"
          :error="errors['size']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-string
          label="Address"
          v-model="modifydata['address']"
          :error="errors['address']"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          label="Plan"
          v-model="modifydata['plan']"
          :error="errors['plan']"
          :items="plans"
          :multiple="false"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6">
        <lb-dropdown
          label="Account Manager"
          v-model="modifydata['accountmanager']"
          :error="errors['accountmanager']"
          :items="allUsers"
          multiple
          itemtext="name"
          itemvalue="_id"
          class="always-float-label"
        />
      </v-col>
      <v-col class="col-6 d-flex justify-space-between align-center">
  <!-- Gen AI with progress on right -->
      <div class="d-flex align-center">
        <label class="mr-3 text-body-2 font-weight-medium">Gen AI</label>
        <div class="d-flex align-center">
          <v-switch
            v-model="modifydata['aiEnabled']"
            @change="$emit('ai-enabled', modifydata)"
            class="font-size-xm mt-0"
            color="success"
            base-color="purple lighten-4"
            hide-details
            inset
          />
          <v-progress-circular
            v-if="aiEnabledLoading"
            indeterminate
            color="green"
            size="20"
            width="2"
            class="ml-5"
           
          ></v-progress-circular>
          <v-text-field v-if="modifydata['aiEnabled']"
          v-model.number="modifydata.aiLimit" label="AI Limit"
          class="ml-5 mt-2" dense outlined type="number"
          style="max-width: 120px;"
          :rules="[v => !!v || 'AI Limit is required']" required />

        </div>
      </div>

      <!-- User Permission -->
      <div class="d-flex align-center">
        <label class="mr-3 text-body-2 font-weight-medium">User Permission</label>
        <div class="d-flex align-center">
          <v-switch
            v-model="modifydata['user_permissions_superadmin']"
            @change="$emit('user-permission-enabled', modifydata)"
            class="font-size-xm mt-0"
            color="success"
            base-color="purple lighten-4"
            hide-details
            inset
          />
          <v-progress-circular
            v-if="userPermissionLoading"
            indeterminate
            color="green"
            size="20"
            width="2"
            class="ml-5"
          ></v-progress-circular>
        </div>
      </div>

      <!-- Notification -->
      <div class="d-flex align-center">
        <label class="mr-3 text-body-2 font-weight-medium">Notification</label>
        <v-switch
          v-model="modifydata['schedulerEnabled']"
          class="font-size-xm mt-0"
          color="success"
          base-color="purple lighten-4"
          hide-details
          inset
        />
      </div>

      <!-- SOD -->
      <div class="d-flex align-center">
        <label class="mr-3 text-body-2 font-weight-medium">SOD</label>
        <v-switch
          v-model="localIsEnabled"
          class="font-size-xm mt-0"
          color="success"
          base-color="purple lighten-4"
          hide-details
          inset
        />
      </div>
    </v-col>
    <v-col class="col-6 d-flex align-center">
      <!-- FBC Shortcut Pin Count -->
      <div class="d-flex align-center">
        
        <div class="d-flex align-center">
          <v-text-field
          v-model.number="modifydata.pinCount"
          label="Shortcut Pin Count"
          class="mt-2" dense outlined type="number"
          style="max-width: 120px; width: 120px;"
          min="-1" max="10"
          :hint="modifydata.pinCount === -1 ? '-1 means disabled' : ''"
          :persistent-hint="modifydata.pinCount === -1"
          :rules="[v => (v >= -1 && v <= 10) || 'Value must be -1 to 10']"
          @keypress="(e) => { if (!/[\d-]/.test(e.key) || (e.key === '-' && e.target.value.length > 0)) e.preventDefault(); }"
          @input="(v) => { const n = parseInt(v); if (!isNaN(n)) modifydata.pinCount = Math.min(10, Math.max(-1, n)); }" />
        </div>
        <!-- Chatbot -->
        <div class="d-flex align-center ml-6">
          <label class="mr-3 text-body-2 font-weight-medium">Chatbot</label>
          <v-switch
            v-model="modifydata['chatbotEnabled']"
            class="font-size-xm mt-0"
            color="success"
            base-color="purple lighten-4"
            hide-details
            inset
          />
        </div>
      </div>

    </v-col>
    </v-row>
    <div class="text-center pb-0">
      <v-btn
        @click="$emit('cancel')"
        text
        class="mr-2 secondaryBtn"
        ><p>Cancel</p></v-btn
      >
      <v-btn
        v-if="addflag"
        color="primary"
        @click="handleSave"
        elevation="0"
        ><p>Save</p></v-btn
      >
      <v-btn
        v-else-if="editflag"
        color="primary"
        @click="handleUpdate"
        elevation="0"
        ><p>Update</p></v-btn
      >
    </div>
  </v-form>
</template>

<script>
export default {
  name: 'EntityForm',
  props: {
    addflag: Boolean,
    editflag: Boolean,
    modifydata: Object,
    errors: Object,
    selectdata: Object,
    industries: Array,
    sectors: Object,
    size: Array,
    plans: Array,
    allUsers: Array,
    isEnabled: Boolean,
    aiEnabledLoading: Boolean,
    userPermissionLoading: Boolean
  },
  data() {
    return {
      localIsEnabled: this.isEnabled
    }
  },
  created() {
    if (this.modifydata && (this.modifydata.pinCount == null)) {
      this.$set(this.modifydata, 'pinCount', -1);
    }
  },
  watch: {
    isEnabled(newVal) {
      this.localIsEnabled = newVal
    }
  },
  methods: {
    handleSave() {
      if (!this.$refs.entityForm.validate()) return;
      this.$emit('save');
    },
    handleUpdate() {
      if (!this.$refs.entityForm.validate()) return;
      this.$emit('update', this.localIsEnabled);
    }
  }
}
</script>
<style>
.always-float-label.v-text-field--outlined .v-label {
  transform: translateY(-1.2em) scale(0.75);
  font-size: 0.85em;
  background: #ffffff;
  padding: 0 0.2em;
}
</style>